import { render, staticRenderFns } from "./sectionTransfer.vue?vue&type=template&id=626b2e7c&"
import script from "./sectionTransfer.vue?vue&type=script&lang=js&"
export * from "./sectionTransfer.vue?vue&type=script&lang=js&"
import style0 from "./sectionTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports